module.exports = __webpack_public_path__ + "assets/media/l-0.03e054c1.svg";